import {
  City,
  County,
  CountyFips,
  DomainSessionId,
  DomainUserId,
  HealthcareSessionId,
  HealthcareUserId,
  USAState,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import { z } from 'zod';

export const UpdateProspectLocationParameters = z
  .object({
    stateAcronym: USAStateAcronym,
    state: USAState,
    county: County,
    city: City,
    countyFips: CountyFips,
  })
  .partial()
  .merge(
    z.object({
      sessionId: HealthcareSessionId,
      userId: HealthcareUserId,
      zipCode: ZipCode,
      domainUserId: DomainUserId.optional(),
      domainSessionId: DomainSessionId.optional(),
    }),
  );

export type UpdateProspectLocationParameters = z.infer<
  typeof UpdateProspectLocationParameters
>;
